export type ArrearsFollowUpCase = {
  reviewed_handling?: {kind:string;access_end_date?:string;reason?:string} | null;
  customer_subscriptions?: {status?:string} | {status?:string}[];
  customer_id?: string;
  subscription_id?: string;
  phase?: string;
  review_reason?: string | null;
  last_error?: string | null;
  pause_until?: string | null;
  pause_reason?: string | null;
  last_success_at?: string | null;
  import_hold?: boolean;
  import_review_kind?: string | null;
  import_review_reason?: string | null;
};

export function needsArrearsReview(row: ArrearsFollowUpCase) {
  return Boolean(row.import_hold || row.review_reason || row.last_error || row.pause_until);
}

export function arrearsFollowUp(rows: ArrearsFollowUpCase[] | null, enabled: boolean | null) {
  if (rows === null) return { kind: "waiting", label: "Opvolging onbekend", reason: "De gegevens over de opvolging zijn nog niet beschikbaar." };
  const review = rows.find(needsArrearsReview);
  if (review) return {
    kind: "manual", label: "Handmatige controle nodig",
    reason: review.import_review_reason || review.review_reason || review.last_error || review.pause_reason || "Er is een betalingsregeling of uitstel afgesproken.",
  };
  if (!rows.length || rows.some(row => !row.last_success_at)) return {
    kind: "waiting", label: "Nog niet beoordeeld", reason: "De abonnements- en factuurgegevens moeten eerst volledig worden gecontroleerd.",
  };
  const reviewedCancellation=rows.find(row=>row.reviewed_handling?.kind==='cancellation');
  if(reviewedCancellation) {
    const subscription=Array.isArray(reviewedCancellation.customer_subscriptions)?reviewedCancellation.customer_subscriptions[0]:reviewedCancellation.customer_subscriptions;
    const completed=['ended','stopped'].includes(subscription?.status||'');
    return {kind:completed?'completed':'planned',label:completed?'Afgerond':'Gepland',reason:completed?'De opzegging is verwerkt; eventuele openstaande facturen blijven gecontroleerd.':`Opzegging gepland per ${reviewedCancellation.reviewed_handling?.access_end_date}. Openstaande facturen blijven gecontroleerd.`};
  }
  if(rows.some(row=>row.reviewed_handling?.kind==='temporary_block'))return {kind:'automatic',label:'Tijdelijk geblokkeerd',reason:'Blijft lid. Betalingen worden gecontroleerd; toegang wordt hersteld zodra de achterstand is voldaan. Geen automatische beëindiging.'};
  if (rows.every(row => row.phase === "stopped")) return { kind: "completed", label: "Afgerond", reason: "De beëindiging is verwerkt." };
  if (enabled !== true) return {
    kind: "paused", label: enabled === false ? "Automatisering gepauzeerd" : "Opvolging onbekend",
    reason: enabled === false ? "De automatische verwerking staat uit." : "De instelling voor automatische verwerking kon niet worden opgehaald.",
  };
  return { kind: "automatic", label: "Automatisch", reason: "De beheertool volgt dit dossier op. Een nieuwe uitzondering wordt gemarkeerd voor handmatige controle." };
}

export function ArrearsFollowUp({ rows, enabled, showReason = false }: { rows: ArrearsFollowUpCase[] | null; enabled: boolean | null; showReason?: boolean }) {
  const state = arrearsFollowUp(rows, enabled);
  return <div className="arrears-follow-up" title={state.reason}>
    <span className={`badge ${state.kind === "manual" ? "warning" : state.kind === "automatic" ? "success" : "muted"}`}>{state.label}</span>
    {showReason && <div className="cell-subtext arrears-follow-up-reason">{state.reason}</div>}
  </div>;
}
